import { useNavigate } from 'react-router-dom';
import { videos } from '@/mocks/videos';
import VideoCard from '@/components/feature/VideoCard';
import SectionHeading from '@/components/base/SectionHeading';

export default function LatestGrid() {
  const navigate = useNavigate();
  const latest = [...videos]
    .sort((a, b) => (a.updateDate < b.updateDate ? 1 : -1))
    .slice(0, 12);

  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-8 md:py-16">
        <SectionHeading
          eyebrow="最新上架"
          title="最新影片推荐"
          description="按更新时间倒序，第一时间发现刚刚上线的热门影视内容"
          actionLabel="查看全部影视"
          onAction={() => navigate('/category/movie')}
        />
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5 lg:grid-cols-4 xl:grid-cols-6">
          {latest.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </div>
    </section>
  );
}